import { render, staticRenderFns } from "./SubNav.vue?vue&type=template&id=462f789b&scoped=true"
import script from "./SubNav.vue?vue&type=script&lang=js"
export * from "./SubNav.vue?vue&type=script&lang=js"
import style0 from "./SubNav.vue?vue&type=style&index=0&id=462f789b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462f789b",
  null
  
)

export default component.exports